import React, { useState } from "react";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { RadioContainer } from "../../../commons";
import { CloseIcon, FilterIcon } from "../../../../assets/images";

type RadioOptionType = {
  id: string;
  name: string;
};
const ASSIGNED_USERS_FILTER_OPTION: RadioOptionType[] = [
  {
    id: "1",
    name: "Internal Users",
  },
  {
    id: "2",
    name: "External Users",
  },
];

type AppProps = {
  setUserType: (data: string) => void;
  handleSubmit: () => void;
  userType: string;
  clearFilter: boolean;
  multiSelectData: any;
};

const AssignedUserListFilter = ({
  setUserType,
  userType,
  handleSubmit,
  clearFilter,
  multiSelectData,
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);
  const handleSetAssignedUsersValue = (radioValue: string) => {
    setUserType(radioValue);
  };
  const clearFilterData = () => {
    setUserType("");
  };

  const empty = () => {
    setUserType(multiSelectData);
  };
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        // resetFilterData()
        clearFilter ? empty() : clearFilterData();
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        caret
        color="secondary"
        style={
          toggle
            ? {
                color: "#dd4433",
                border: "1px solid #dd4433",
                backgroundColor: "#fff6f5",
              }
            : { border: "1px solid#bfcbe1" }
        }
        outline
      >
        <img src={FilterIcon} alt="" />
        <span className={clearFilter ? "filter-count" : ""}>
          <span>{clearFilter ? 1 : ""}</span>
        </span>
      </DropdownToggle>

      <DropdownMenu right>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
                // clearFilter()
                // setClearFilter(false)
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />
          <div className="mt-4 ml-1">
            <h4>Users</h4>
            <div>
              <RadioContainer
                optionsList={ASSIGNED_USERS_FILTER_OPTION}
                handleSetRadioValue={handleSetAssignedUsersValue}
                radioValue={userType}
                alignment="vertical"
              />
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-end p-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilterData();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              handleSubmit();
              setToggle(!toggle);
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default AssignedUserListFilter;
